<script lang="ts">
  export let title: string
  export let subtitle: string
  export let background: string
</script>

<div class="card">
  <div class="image" style:background={`url(${background}) no-repeat center/cover`} />
  <div class="content">
    <div class="title">{title}</div>
    <div class="subtitle">{subtitle}</div>
  </div>
</div>

<style lang="scss">
  .card {
    box-shadow: 0 2px 8px 0 #10107A29;
    border-radius: 10px;
    display: flex;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .image {
      width: 100%;  
      min-height: 275px;
      flex: 1;
      border-radius: 10px 0 0 10px;

      @media (max-width: 768px) {
        border-radius: 10px 10px 0 0;
      }

      @media (max-width: 576px) {
        min-height: 173px;
      }
    }

    .content {
      flex: 1;
      display: flex;
      justify-content: center;
      height: auto;
      flex-direction: column;

      @media (max-width: 768px) {
        padding: 20px 30px;
      }

      @media (max-width: 576px) {
        padding: 16px 12px;
      }

      .title,
      .subtitle {
        padding-left: 32px;

        @media (max-width: 768px) {
          padding-left: 0;
        }
      }

      .title {
        font-size: 30px;
        font-weight: 600;
        line-height: 39px;
        color: #30333D;

        @media (max-width: 576px) {
          font-size: 20px;
          line-height: 29px;
        }
      }

      .subtitle {
        color: #5A5F6D;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        margin-top: 16px;

        @media (max-width: 768px) {
          margin-top: 8px;
        }

        @media (max-width: 576px) {
          font-size: 14px;
          margin-top: 0;
        }
      }
    }
  }
</style>